import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/grunndata/$systemName")({
  beforeLoad: ({ params }) => {
    return {
      getTitle: () => params.systemName,
    };
  },
});
